import React, { memo } from 'react'
import { LANGUAGE_ENUM as LANG } from '@/shared'
import { useTranslation } from 'react-i18next'
import { getCurrentLanguage } from '@/i18next'
import { toValue } from '@pages/RequirementLaborResources'
import { AntdTable } from '@/components/AntdTable/AntdTable'

export const AnimalHusbandryTable = memo(({item}) => {
	const { t } = useTranslation()
	const lang = getCurrentLanguage()

	const columnAnimalHusbandry = [
		{
			title: t('requirement_labor_resources.work_name'),
			dataIndex: 'workName',
			key: 'workName',
			render: (text, record, index) => {
				let label = {
					[LANG.kz]: record.workNameKz,
					[LANG.rus]: record.workNameRu,
				}
				return label[lang]
			},
		},
		{
			title: t('requirement_labor_resources.profession_name'),
			dataIndex: 'professionName',
			key: 'professionName',
			render: (text, record, index) => {
				let label = {
					[LANG.kz]: record.professionNameKz,
					[LANG.rus]: record.professionNameRu,
				}
				return label[lang]
			},
		},
		{
			title: t('requirement_labor_resources.standart_number'),
			dataIndex: 'headCount',
			key: 'headCount',
			render: (text, record, index) => {
				return toValue(text)
			},
		},
	]
	return (
		<AntdTable
			columns={columnAnimalHusbandry}
			dataSource={item?.data}
			pagination={false}
			rowKey={(record) => `${record.workNameRu}-${record.headCount}`}
		/>
	)
})